/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-lock': {
    width: 16,
    height: 32,
    viewBox: '0 0 16 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(4 12)" _fill="#000" fill-rule="nonzero"><path pid="0" class="st1" d="M7.158 3.958h-.316V2.812C6.842 1.26 5.57 0 4 0S1.158 1.26 1.158 2.813v1.145H.842A.838.838 0 000 4.792v4.375c0 .46.377.833.842.833h6.316A.838.838 0 008 9.167V4.792a.838.838 0 00-.842-.834zm-4 2.5a.843.843 0 011.633-.29.83.83 0 01-.37 1.008v.949c0 .23-.188.417-.421.417a.419.419 0 01-.421-.417v-.949a.83.83 0 01-.421-.718zM2.21 2.812c0-.978.8-1.77 1.789-1.77.988 0 1.79.792 1.79 1.77v.938a.21.21 0 01-.211.208H2.42a.21.21 0 01-.21-.208v-.938z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-lock.js